// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"MedicalRecordStatusBadge_badgeWrapper__YNIxX","badge":"MedicalRecordStatusBadge_badge__8Sc5H","retryButton":"MedicalRecordStatusBadge_retryButton__QemLp"};